import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useTheme } from '../../../../contexts/ThemeContext'

const ColChart = ({ data, seriesNames, colors, title, height }) => {
  const { theme } = useTheme()
  const [chartData, setChartData] = useState()

  useEffect(() => {
    if (theme === 'dark') {
      renderChart('#d1d5db')
    } else if (theme === 'light') {
      renderChart('#6b7280')
    }
  }, [theme, data, seriesNames, colors])

  function renderChart(labelColor) {
    const defaultColors = ['#F89C74', '#66C5CC', '#8BE0A4', '#DCB0F2', '#F6CF71']

    setChartData({
      series: (data || []).map((seriesData, idx) => ({
        name: seriesNames?.[idx] || `Series ${idx + 1}`,
        data: seriesData,
        color: colors?.[idx] || defaultColors[idx % defaultColors.length],
      })),
      options: {
        chart: {
          fontFamily: 'DM Sans, sans-serif',
          stacked: true,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '80%',
            endingShape: 'rounded',
          },
        },
        legend: {
          show: true,
          position: 'right',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Inter',
          fontWeight: 400,
          labels: {
            colors: labelColor,
            useSeriesColors: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            const num = Number(val || 0);
            if (num === 0) return '0.00';
            return num.toPrecision(3);
          }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          title: { text: 'Months', style: { color: labelColor, fontWeight: '500', fontSize: '12px' } },
          categories: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ],
          labels: { style: { colors: labelColor } },
        },
        yaxis: {
          title: { text: 'Tonnes of CO2', style: { color: labelColor, fontWeight: '500', fontSize: '14px' } },
          labels: {
            style: { colors: labelColor },
            formatter: function (val) {
              const num = Number(val || 0);
              if (num === 0) return '0';
              return num.toPrecision(3);
            }
          },
        },
        responsive: [
          { breakpoint: 480, options: { legend: { position: 'bottom', offsetX: -10, offsetY: 0 } } },
        ],
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: function (val) {
              const num = Number(val || 0);
              if (num === 0) return '0.00 kg CO2';
              return `${num.toPrecision(3)} kg CO2`;
            }
          },
        },
      },
    })
  }

  return (
    <div className="overflow-hidden sm:rounded-lg bg-white dark:bg-darkbg4 px-4 py-6 border">
      <h3 className="text-left px-6">{title}</h3>
      {chartData && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={height}
        />
      )}
    </div>
  )
}

export default ColChart
